import React, { useRef, useState, useEffect } from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BASE_URL = `${process.env.REACT_APP_LINK}`;
const formatPrice = (value) => {
  const num = Number(value);
  if (isNaN(num) || num <= 0) return 'N/A';

  if (num >= 1e7) {
    return `${(num / 1e7).toFixed(2)} Crore`;
  } else if (num >= 1e5) {
    return `${(num / 1e5).toFixed(2)} Lakh`;
  } else {
    return num.toLocaleString('en-IN'); // fallback for values < 1 Lakh
  }
};

const getPriceAndAreaDetails = (flatTypeArray) => {
  let smallest = null;
  let largest = null;

  flatTypeArray.forEach(ft => {
    if (Array.isArray(ft.builtUpAreas)) {
      ft.builtUpAreas.forEach(area => {
        const price = parseFloat(area.expectedPrice || 0);
        if (!isNaN(price) && price > 0) {
          if (!smallest || price < parseFloat(smallest.expectedPrice)) smallest = area;
          if (!largest || price > parseFloat(largest.expectedPrice)) largest = area;
        }
      });
    }
  });

  return { smallest, largest };
};
// Child component — DO NOT export this directly
const PropertySectionv = ({ title, city }) => {
  const scrollRef = useRef(null);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  console.log(city)
  const parseJSON = (val) => {
    try {
      return typeof val === 'string' ? JSON.parse(val) : val;
    } catch {
      return val;
    }
  };

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError(null);
        // const url = `${BASE_URL}/property/getproperty/search`;
        const [res1, res2, res3] = await Promise.all([
          fetch(`${BASE_URL}/resident/getproperty/HBTR0001`),
          fetch(`${BASE_URL}/commercial/getproperty/HBTR0001`),
          fetch(`${BASE_URL}/rentresident/getproperty/HBTR0001`)
        ]);

        const [json1, json2, json3] = await Promise.all([
          res1.json(),
          res2.json(),
          res3.json()
        ]);

        const parseProps = (item) => {
          const parseJSON = (val) => {
            try {
              return typeof val === 'string' ? JSON.parse(val) : val;
            } catch {
              return val;
            }
          };
          return {
            amenities: parseJSON(item.amenities || "[]"),
            carpetArea: parseJSON(item.carpetArea || "[]"),
            flatType: parseJSON(item.flatType || "[]"),
            expectedPrice: parseJSON(item.expectedPrice || "[]"),
            formImages: parseJSON(item.formImages || "[]"),
            locationAdvantage: parseJSON(item.locationAdvantage || item.locationAdvantages || "[]"),
          };
        };

        const combined = [
          ...json1.map(item => ({ ...item, type: "resident", ...parseProps(item) })),
          ...json2.map(item => ({ ...item, type: "commercial", ...parseProps(item) })),
          ...json3.map(item => ({ ...item, type: "rent", ...parseProps(item) }))
        ];

        const uniqueData = combined.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.property_id === value.property_id)
        );

        const sortedData = uniqueData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setProperties(sortedData);
      } catch (err) {
        setError('Failed to fetch properties. Please try again later.');
        console.error('Error fetching properties:', err);
      } finally {
        setLoading(false);
      }
    };

    if (city) {
      fetchProperties();
    }

  }, []);

  const handlePageChange = (propertyId, propertType) => {
    if (propertType === "Residential") {
      navigate(`/residential-property/${propertyId}`);
    } else if (propertType === "Commercial") {
      navigate(`/commercial-property/${propertyId}`);
    } else if (propertType === "Rent Residential") {
      navigate(`/rent-property/${propertyId}`);
    }
  };

  console.log(properties)

  const filteredProperties = properties.filter((item) => item.city?.toLowerCase() === city.toLowerCase())
  // ✅ Hide entire section when nothing to show
  


  const handleScroll = (direction) => {
    const { current } = scrollRef;
    if (!current) return;

    const scrollAmount = direction === 'left' ? -320 : 320;
    current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  if (!loading && !error && filteredProperties.length === 0) {
    return null;
  }
  return (
    <div className="location-group">
      <div className="header-content">
        <h2 className="section-title">Discover Your Dream Home</h2>
        <p className="section-subtitle">Explore premium homes across top localities in {city}</p>
      </div>
      <h2 className="location-title">{title}</h2>

      <div className="scroll-wrapper">
        <button
          className="scroll-arrow left"
          onClick={() => handleScroll('left')}
        >
          <ChevronLeft size={24} />
        </button>

        <div className="grid-container" ref={scrollRef}>
          {loading ? (
            <div className="loading">Loading properties...</div>
          ) : error ? (
            <div className="error">{error}</div>
          ) : filteredProperties.length === 0 ? (
            <div className="no-properties">No properties found for {city}.</div>
          ) : (
            filteredProperties.map((prop, idx) => {
              const { smallest, largest } = getPriceAndAreaDetails(prop.flatType);
              return <div key={prop.property_id || idx} className="property-card" onClick={() => handlePageChange(prop.property_id, prop.typeofproperty)}>
                <div className="image-wrapper">
                  <img
                    src={prop.formImages && prop.formImages.length > 0 ? `${process.env.REACT_APP_IMAGE_BASE_URL}/Images/Store/${prop.formImages[0]}` : '/placeholder-image.jpg'}
                    alt={prop.building_name}
                  />
                </div>

                <div className="property-info">
                  <h3>{prop.building_name}</h3>
                  <p className="sector">{prop.address}</p>
                  <p className="price">Starting From  {smallest?.expectedPrice > 0 && largest?.expectedPrice > 0 ? (
                    smallest.expectedPrice === largest.expectedPrice ? (
                      `₹ ${formatPrice(smallest.expectedPrice)}`
                    ) : (
                      `₹ ${formatPrice(smallest.expectedPrice)} - ₹ ${formatPrice(largest.expectedPrice)}`
                    )
                  ) : smallest?.expectedPrice > 0 ? (
                    `₹ ${formatPrice(smallest.expectedPrice)}`
                  ) : (
                    `₹ ${formatPrice(largest.expectedPrice)}`
                  )}</p>
                </div>
              </div>
            })
          )}
        </div>

        <button
          className="scroll-arrow right"
          onClick={() => handleScroll('right')}
        >
          <ChevronRight size={24} />
        </button>
      </div>
      {/* <button className="blog-section-chevron-button">View More</button> */}
    </div>
  );
};

// Parent component — THIS is what should be rendered
const PropertyGrid = () => {
  const sections = [
    { title: "Properties in Mumbai Expressway", city: "Mumbai" }
  ];

  return (
    <div className="property-discovery-container">
      {sections.map((section, idx) => (
        <PropertySectionv
          key={idx}
          title={section.title}
          city={section.city}
        />
      ))}
    </div>
  );
};

export default PropertyGrid;
